import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { map, merge, find, path } from 'ramda';
import { mapLinks, NavFrame } from './shared';
import HeaderMailModal from '../HeaderMailModal';

var NavDefinition = function NavDefinition(_ref) {
  var options = _ref.options,
      comp = _ref.comp,
      vertical = _ref.vertical,
      b = _ref.b,
      l = _ref.l,
      isLoggedIn = _ref.isLoggedIn,
      _ref$meEmailMigration = _ref.meEmailMigrationData,
      meEmailMigrationData = _ref$meEmailMigration === undefined ? {} : _ref$meEmailMigration,
      onToggleDoNotShowAgain = _ref.onToggleDoNotShowAgain,
      me = _ref.me;

  var _useState = useState(false),
      modalOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(),
      modalType = _useState2[0],
      setModalType = _useState2[1];

  var modalToggle = function modalToggle() {
    return setOpen(!modalOpen);
  };
  return React.createElement(
    NavFrame,
    { vertical: vertical },
    React.createElement(HeaderMailModal, { open: modalOpen, onToggle: modalToggle, type: modalType, meEmailMigrationData: meEmailMigrationData, onToggleDoNotShowAgain: onToggleDoNotShowAgain, me: me }),
    mapLinks(options, comp, vertical, b, l, { isLoggedIn: isLoggedIn, meEmailMigrationData: meEmailMigrationData, setModalType: setModalType, setOpen: setOpen })
  );
};
NavDefinition.propTypes = process.env.NODE_ENV !== "production" ? {
  options: PropTypes.array.isRequired,
  comp: PropTypes.func,
  vertical: PropTypes.bool,
  b: PropTypes.number,
  l: PropTypes.number
} : {};

NavDefinition.displayName = 'Nav';

export var Nav = NavDefinition;

export var buildNavTree = function buildNavTree(mainOptions, subOptions) {
  return map(function (option) {
    return merge(option, {
      options: path(['options'], find(function (sub) {
        return sub.parent === option.id;
      }, subOptions))
    });
  }, mainOptions);
};